import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getTranslations, loadTranslations } from './utils/getTranslations'

const translationFiles = loadTranslations()

const enTranslations = getTranslations('en', translationFiles)

void i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    resources: {
        en: enTranslations,
    },
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
})

export default i18n
